import React from 'react';

export default ({children, label, ...rest})=> (
	<label className='FormElement' {...rest}>
		{label ? <div className='FormElement_label'>{label}</div> : null}
		<div className='FormElement_body'>{children}</div>
	</label>
);
